module.exports = __webpack_public_path__ + "img/new-s-cross-2023.536cb035.svg";